import { render, staticRenderFns } from "./SeatTypeMaster.vue?vue&type=template&id=59b8903c"
import script from "./SeatTypeMaster.vue?vue&type=script&lang=js"
export * from "./SeatTypeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports